<template lang="pug">
div(v-if='topics.length > 0 && !error' class='mt-2')
  div(class='text-sm font-normal mt-6') Popular topics
  div(class='flex flex-wrap gap-2 mt-4 w-4/5 items-center')
    button(
      v-for='(topic, index) in topics'
      :key='topic.name'
      :aria-label='`Select topic ${topic.name}`'
      :class='getTopicClass(topic.name, index)'
      class='hover:bg-black hover:text-white text-sm px-3 py-2 rounded-full cursor-pointer align-middle'
      @click='selectTopic(topic.name)'
    ) {{ topic.name }}
    button(
      aria-label='Show more topics'
      class='inline-block text-sm font-bold underline cursor-pointer align-middle'
      @click='showMoreTopics = !showMoreTopics'
    ) {{ showMoreTopics ? 'Show less' : 'Show more' }}
</template>

<script setup lang="ts">
const { $sitewideConfig } = useNuxtApp()
const { $device } = useNuxtApp()

const { yotpoId, selectedTopics } = defineProps<{
  yotpoId: string
  selectedTopics: string[]
}>()

const emit = defineEmits(['onSelectTopic'])

const error = ref(false)
const topics = ref<YotpoTopic[]>([])
const showMoreTopics = ref(false)

onMounted(async () => {
  getTopics()
})

async function getTopics() {
  try {
    const url = `https://api-cdn.yotpo.com/v1/topic/${$sitewideConfig.config.yotpoApiKey}/topics.json`
    const res = ref<YotpoTopicsResponse | null>(null)

    res.value = await $fetch<YotpoTopicsResponse>(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: {
        domain_key: yotpoId,
      },
    })

    topics.value = res.value.top_topics.top_mention_topics
  } catch (err) {
    error.value = true
  }
}

function getTopicClass(topic: string, index: number) {
  const num = $device.value.isMobile ? 3 : 7 // Default number of topics to show on mobile vs desktop
  const colors = selectedTopics.includes(topic) ? 'bg-black text-white' : 'bg-gray-lighter'
  const hidden = index > num && !showMoreTopics.value ? 'hidden' : ''
  return `${colors} ${hidden}`
}

function selectTopic(value: string) {
  emit('onSelectTopic', value)
}
</script>
